export type OperationsMode = "live" | "prototype";

export function ModeSelector({
  mode,
  onChange,
}: {
  mode: OperationsMode;
  onChange: (mode: OperationsMode) => void;
}) {
  return (
    <div className="mode-selector" aria-label="Dashboard data mode">
      <button
        type="button"
        aria-pressed={mode === "live"}
        onClick={() => onChange("live")}
      >
        Live
      </button>
      <button
        type="button"
        aria-pressed={mode === "prototype"}
        onClick={() => onChange("prototype")}
      >
        Prototype
      </button>
    </div>
  );
}

export function PrototypeBanner() {
  return (
    <div className="prototype-banner" role="status">
      <strong>PROTOTYPE · SYNTHETIC DATA · NO REAL BETS</strong>
      <span>
        Actions reset when this page reloads and never reach live services.
      </span>
    </div>
  );
}
